import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import SEO from '../../components/SEO';
import { SEO_METADATA } from '../../config/seoMetadata';
import ConcertsListing from './ConcertsListing';
import ConcertDetail from './ConcertDetail';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const Concerts = () => {
  const location = useLocation();
  const seo = SEO_METADATA.concerts;

  // Only show SEO on the listing page, not detail pages
  const isListingPage = location.pathname === '/concerts' || location.pathname === '/concerts/';

  return (
    <div className="min-h-screen flex flex-col">
      {isListingPage && (
        <SEO
          title={seo.title}
          description={seo.metaDescription}
          keywords={seo.keywords}
          canonical="/concerts"
          additionalMetaTags={[
            { property: 'og:title', content: seo.openGraph.title },
            { property: 'og:description', content: seo.openGraph.description }
          ]}
        />
      )}
      <Header variant="dark" />
      <Routes>
        <Route index element={<ConcertsListing />} />
        <Route path=":slug" element={<ConcertDetail />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default Concerts;